module.exports = __webpack_public_path__ + "img/banner02.81eea713.png";